import LoginPanel from './src/login-panel';
export default LoginPanel;